import { AgentEndpoints, RequestMethods, useRequest } from '@src/shared';

import type { CommonResponse } from '@shared/types';

export const useDeleteProfileDraft = () => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    unknown,
    never,
    CommonResponse
  >({
    params: {
      key: 'deleteProfileDraft',
      method: RequestMethods.POST,
      url: `${AgentEndpoints.AGENTS}/contracts/personal-data-cancel`,
      fetchManual: true,
      request: {},
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
